<template>
  <div class="w-100">
    <!-- <div class="w-100">
      <small>（購物車結帳時總計1000元，以總計1000元再打會員／滿額打折）</small>
    </div> -->

    <table class="table table-sm table-bordered whole__building__box">
      <tbody>
        <tr>
          <td class="building__title" rowspan="2">全館折扣</td>
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center">
                <span>打（</span>
                <b-form-select class="form-control w-25 text-center" :options="discountRange"
                  v-model="cartSetting.wholeBuilding.value">
                </b-form-select>
                <span>）折</span>
              </div>

              <ul class="building__box__example__list">
                <li>
                  <small>於結帳時所有消費者均套用此折扣計算</small>
                </li>
                <li>
                  <div class="d-flex flex-column">
                    <small>當啟用全館折扣後，所有折扣設定將被忽略</small>
                    <small class="text-danger">包括：單品買滿折扣、折扣區買滿折扣、加購區折扣、會員等級打折、結帳滿額打折...等將被忽略</small>
                  </div>
                </li>
                <li>
                  <small>適用於臨時性短期活動，例如：開幕期間大特價</small>
                </li>
              </ul>

            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="cartSetting.wholeBuilding.use" value="1" unchecked-value="0">使用全館優惠代號：</b-form-checkbox>
                <b-input-group class="w-25">
                  <b-form-input class="form-control w-25" v-model="cartSetting.wholeBuilding.code">
                  </b-form-input>
                  <b-input-group-append>
                    <button class="btn btn-sm btn-primary" @click="autoDiscountCode()">自動</button>
                  </b-input-group-append>
                </b-input-group>
                <small>（最少6碼、最多10碼 不分大小寫）</small>
              </div>

              <ul class="building__box__example__list">
                <li>
                  <small>消費者若輸入全館優惠碼，方使用全館折扣，反之則仍會進型特殊會員等級折扣、結帳滿額打折</small>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table table-sm table-bordered another__discount__box">
      <tbody>
        <tr>
          <th class="discount__box__title">特殊會員等級折扣</th>
          <th class="discount__box__title">購物結帳滿額</th>
        </tr>
        <tr>
          <td>
            <div class="w-100">
              <table class="table table-sm table-bordered m-0 mb-2 member__level__box">
                <thead>
                  <tr class="discountTitle">
                    <th class="text-center">排序</th>
                    <th class="text-center">等級名稱</th>
                    <th class="text-center">折扣</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(level, index) in memberLevel" :key="'member__level__' + index">
                    <td style="width: 90px">
                      <div class="d-flex align-items-center justify-content-between">
                        <span>{{ index+1 }}</span>
                        <button class="btn btn-sm btn-primary"
                          @click="memberLevelManage(level, 'update')">管理</button>
                      </div>
                    </td>
                    <td class="text-center" style="vertical-align: middle">{{ level.name}}</td>
                    <td class="text-center" style="vertical-align: middle">
                      <div class="w-100"
                        v-if="level.discountModel == 'percentage' && level.discountValue != 0">
                        <div class="d-flex align-items-center justify-content-center">
                          <span>折扣</span>
                          <span>{{level.discountValue}}</span>
                          <span>折</span>
                        </div>
                      </div>
                      <div
                        v-else-if="level.discountModel == 'realNumber' && level.discountValue != 0">
                        <div class="d-flex align-items-center justify-content-center">
                          <span>折價</span>
                          <span>{{level.discountValue |currency()}}</span>
                          <span>元</span>
                        </div>
                      </div>
                      <div v-else-if="level.discountValue == 0">
                        不折扣
                      </div>

                    </td>
                  </tr>
                </tbody>
              </table>


              <div class="w-100">
                <button class="btn btn-sm btn-primary" @click="memberLevelManage()">
                  新增 "會員等級"
                </button>
                <div class="w-100">
                  <small class="text-danger">請於［會員管理］設定會員等級</small>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="w-100">
              <div class="d-flex align-items-center mb-2">
                <span style="width: 60px">折價條件</span>
                <div style="min-width: 100px">
                  <select class="form-control" v-model="cartSetting.payFull.limit">
                    <option value="">不使用</option>
                    <option value="buyCount">購買數量</option>
                    <option value="buyMoney">購買額度</option>
                  </select>
                </div>
                <span style="width: 60px">折價方式</span>
                <div style="width: 100px">
                  <select class="form-control" v-model="cartSetting.payFull.model">
                    <option value="percentage">折扣</option>
                    <option value="realNumber">折現</option>
                  </select>
                </div>
              </div>
              <template
                v-if="(cartSetting.payFull.model == 'percentage' || cartSetting.payFull.model == 'realNumber') && cartSetting.payFull.limit">
                <div class="w-100">
                  <div class="d-flex align-items-center" v-for="(key, index) in 5"
                    :key="'payFull__box__' + key">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control"
                        v-model="cartSetting.payFull.discountList[index].limit" />
                      <span v-if="cartSetting.payFull.limit == 'buyMoney'">元</span>
                      <span v-if="cartSetting.payFull.limit == 'buyCount'">件</span>
                    </div>
                    <div class="d-flex align-items-center ml-2"
                      v-if="cartSetting.payFull.model=='percentage'">
                      <span>打</span>
                      <b-form-select style="width: 100px" :options="discountRange"
                        v-model="cartSetting.payFull.discountList[index].value">
                      </b-form-select>
                      <span>折</span>
                    </div>

                    <div class="d-flex align-items-center ml-2"
                      v-if="cartSetting.payFull.model=='realNumber'">
                      <span>折</span>
                      <input type="number" class="form-control" style="width: 100px"
                        v-model="cartSetting.payFull.discountList[index].value">
                      <span>元</span>
                    </div>
                  </div>

                </div>
              </template>
              <!-- <template v-else-if="cartSetting.payFullModel == 'realNumber'">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control" />
                      <span>元</span>
                    </div>
                    <div class="d-flex align-items-center ml-2">
                      <span>折</span>
                      <b-form-select :options="discountRange"></b-form-select>
                      <span>元</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control" />
                      <span>元</span>
                    </div>
                    <div class="d-flex align-items-center ml-2">
                      <span>折</span>
                      <b-form-select :options="discountRange"></b-form-select>
                      <span>元</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control" />
                      <span>元</span>
                    </div>
                    <div class="d-flex align-items-center ml-2">
                      <span>折</span>
                      <b-form-select :options="discountRange"></b-form-select>
                      <span>元</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control" />
                      <span>元</span>
                    </div>
                    <div class="d-flex align-items-center ml-2">
                      <span>折</span>
                      <b-form-select :options="discountRange"></b-form-select>
                      <span>元</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control" />
                      <span>元</span>
                    </div>
                    <div class="d-flex align-items-center ml-2">
                      <span>折</span>
                      <b-form-select :options="discountRange"></b-form-select>
                      <span>元</span>
                    </div>
                  </div>
                </div>
              </template> -->

              <ul class="discount__box__example__list">
                <li>
                  <small>金額（件數）請由低到高依序填寫</small>
                </li>
                <li>
                  <small>此折扣指單次消費，並非累計消費</small>
                </li>

                <li style="color:black;">
                  <small>滿額優惠說明：</small>
                  <b-form-textarea v-model="cartSetting.payFull.remark"></b-form-textarea>
                </li>
                <li>
                  <small class="text-danger">上述將會顯示於購物車步驟一內供消費者看</small>
                </li>
              </ul>

            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span>
              <strong class="text-danger">特殊會員等級折扣</strong>
              與
              <strong class="text-danger">購物滿多少打幾折</strong>
              是否要重複計算？
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="d-flex flex-column example__box">

              <b-form-radio-group class="w-100" v-model="cartSetting.discountRepeat">
                <b-form-radio value="notRepeat">不重複計算(折扣低的優先)</b-form-radio>

                <div class="d-flex align-items-center">
                  <span class="example__box__tag">例一</span>
                  <small>白金會員打8折、購物滿1000元打9折：金額以8折計算</small>
                </div>

                <div class="d-flex align-items-center">
                  <span class="example__box__tag">例二</span>
                  <small>白金會員打8折、購物滿1000元打7折：金額以7折計算</small>
                </div>

                <b-form-radio value="repeat">重複計算(再折扣)</b-form-radio>

                <div class="d-flex align-items-center">
                  <span class="example__box__tag">例三</span>
                  <small>白金會員打8折、購物滿1000元打9折：金額以8折＊9折＝7.2折計算</small>
                </div>
              </b-form-radio-group>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table table-sm table-bordered member__level__box">
      <tbody>
        <tr>
          <td>優惠代號管理</td>
        </tr>
        <tr>
          <td>
            <div class="d-flex flex-column text-left">
              <span>額度管理</span>
              <table class="table table-sm table-bordered mb-2">
                <tbody>
                  <tr>
                    <th class="level__box__title bg-white">排序</th>
                    <th class="level__box__title bg-white">折扣代號</th>
                    <th class="level__box__title bg-white">使用狀態</th>
                    <th class="level__box__title bg-white">折價方式</th>
                    <th class="level__box__title bg-white">可用數量</th>
                    <th class="level__box__title bg-white">使用期間</th>
                  </tr>

                  <tr v-for="(code, index) in codeList" :key="'code__list__' + index">
                    <td class="level__box__title bg-white">
                      <div class="d-flex align-items-center justify-content-between">
                        <span>{{index + 1}}</span>
                        <button class="btn btn-sm btn-primary" @click="discountCodeManage(code, 'update')">
                          管理
                        </button>
                      </div>
                    </td>
                    <td class="level__box__title bg-white">
                      {{ code.code }}
                    </td>
                    <td class="level__box__title bg-white">
                      <span
                        :class="'text-'+discountCodeState(code).color">{{ discountCodeState(code).text }}</span>
                    </td>
                    <td class="level__box__title bg-white">
                      {{ discountMethod(code) }}
                    </td>
                    <td class="level__box__title bg-white">
                      {{ discountCodeNumber(code).infor }}
                    </td>
                    <td class="level__box__title bg-white">
                      {{ discountCodeTime(code) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="w-100">
                <button class="btn btn-sm btn-primary" @click="discountCodeManage()">
                  新增 "優惠代號"
                </button>
                <ul class="level__box__example__list">
                  <li>
                    <small>消費者在輸入時，僅只能輸入一組優惠代號，不得同時多組使用</small>
                  </li>
                  <li>
                    <small>若有設定最低消費金額時，未超過消費金額提示錯誤</small>
                  </li>
                  <!-- <li>【檢視】僅在此頁面僅供檢視，如需更改詳細設定，請至功能=>個別設定</li> -->
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex flex-fill justify-content-center">
      <button class="btn btn-sm btn-primary" @click="baseDiscountSave()">儲存</button>
    </div>

    <discount-code :method="discountTemp.method" :open.sync="discountTemp.show" :discountTemp="discountTemp.data" v-if="discountTemp.show"></discount-code>
    <member-level :method="memberLevelTemp.method" :open.sync="memberLevelTemp.show" :levelTemp="memberLevelTemp.data" v-if="memberLevelTemp.show"></member-level>
    
  </div>
</template>

<script>
  import totalDiscount from '@/js/cartManage/totalDiscount';

  export default totalDiscount;

</script>

<style lang="scss">
  .whole__building__box {
    .building__title {
      text-align: center;
      vertical-align: middle;
    }

    .building__box__example__list {
      padding: 0 0 0 20px;
      margin: 0;
    }
  }

  .another__discount__box {
    .discount__box__title {
      text-align: center;
      vertical-align: middle;
    }

    .discount__box__example__list {
      padding: 0 0 0 20px;
      margin: 0;
    }

    .example__box {
      .example__box__tag {
        border: 1px solid #eeeeee;
        padding: 0 5px;
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }
  }

</style>
